import Quill from 'quill'
const Clipboard = Quill.import('modules/clipboard')
const Delta = Quill.import('delta')

/**
 * @see https://gist.github.com/ryanhaney/d4d205594b2993224b8ad111cebe1a13
 * @see https://quilljs.com/docs/modules/
 */
class PlainClipboard extends Clipboard {
  onPaste (e) {
    e.preventDefault()
    const range = this.quill.getSelection()
    const text = e.clipboardData.getData('text/plain')
    const delta = new Delta()
      .retain(range.index)
      .delete(range.length)
      .insert(text)
    const index = text.length + range.index
    const length = 0
    this.quill.updateContents(delta, 'silent')
    this.quill.setSelection(index, length, 'silent')
    this.quill.scrollIntoView()
  }
}

export default PlainClipboard



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-quill-editor/src/PlainClipboard.js